import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { ShareEntitiesEnums } from 'src/app/enums/chat-enums';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { SingleItem } from 'src/app/services/http-services/items/items-interfaces';
import { DeleteModalText } from 'src/app/services/http-services/lists/lists-http-intterfaces';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import {UserRoles} from '../../enums/general-enums';

@Component({
  selector: 'app-single-item',
  templateUrl: './single-item.component.html',
})
export class SingleItemComponent implements OnInit {
  tabSelected = 'info';
  itemId = 0;
  item!: SingleItem;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  isShareProfileModalOpen = false;
  ShareEntitiesEnums = ShareEntitiesEnums;
  itemUrl = '';
  isViewMoreModalOpen = false;
  isDeleteModalOpen = false;
  modalText: DeleteModalText = { title: '', description: '', button: '' };
  loggedUser: any;
  isReportModalOpen = false;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  selectedMedia: any = null;

  constructor(
    private listsHttpService: ListsHttpService,
    private actRoute: ActivatedRoute,
    private itemsHttpService: ItemsHttpService,
    private router: Router,
    private toastService: ToastrService,
    private authenticationHelperService: AuthenticationHelperService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUser = this.authenticationHelperService.getUserData;
      this.itemUrl = window.location.href;
    }
    this.getParams();
  }

  getParams(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.itemId = Number(params.get('id'));
      this.getSingleItem();
      this.getPublicSingleItem();
    });
  }

  getSingleItem(): void {
    this.listsHttpService.getSingleItem(this.itemId).then((res: any) => {
      this.item = res;
    });
  }

  getPublicSingleItem(): void {
    this.listsHttpService.getPublicSingleItem(this.itemId).then((res: any) => {
      const publicItem = res;
      this.meta.updateTag({
        property: 'og:title',
        content: `${publicItem.name} by ${publicItem.lyst.user.name} - TheLysts`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `${publicItem.name} on the ${publicItem.lyst.title} Lyst by ${publicItem.lyst.user.name} - TheLysts`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: publicItem.lyst_item_image_url !== null ? publicItem.lyst_item_image_url : 'assets/images/og-image.png'
      });
      this.meta.updateTag({
        property: 'og:url', content: this.router.url
      });
    });
  }

  selectTab(tabSelected: string): void {
    this.tabSelected = tabSelected;
  }

  additemToFavorites(): void {
    this.itemsHttpService.addItemToFavorites(this.itemId).then((res: any) => {
      this.getSingleItem();
    });
  }

  openDeleteModal(): void {
    this.isDeleteModalOpen = true;
    this.modalText.title = 'ITEMS.delete_item';
    this.modalText.description = 'Are you sure you wish to delete this item? This action cannot be undone.';
    this.modalText.button = 'GENERAL.delete';
  }

  openDropdown(event: any): void {
    this.isViewMoreModalOpen = !this.isViewMoreModalOpen;
  }

  deleteItem(): void {
    this.isDeleteModalOpen = false;
    this.itemsHttpService.deleteItem(this.itemId).subscribe((response: any) => {
      this.toastService.success(response.message);
      this.router.navigateByUrl('lists/my_lists');
    });
  }

  reportItem(): void {
    this.isReportModalOpen = true;
    // const reqBody = {
    //   body: this.item.id.toString()
    // }
    // this.itemsHttpService.reportItem(this.item.id, reqBody).subscribe((res: any) => {
    // })
  }

  triggerFileInput(event: Event): void {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    const formData = new FormData();
    if (file) {
      formData.append('image', file);
    }
    this.itemsHttpService.addImageToItem(this.item.id, formData).then((response: any) => {
      this.fileInput.nativeElement.value = '';
      this.getSingleItem();
    });
  }

  deleteImage(image: any): void {
    this.itemsHttpService.deleteImageFromItem(this.item.id, image.id).then((response: any) => {
      this.toastService.success(response.data);
      this.getSingleItem();
    });
  }

  protected readonly UserRoles = UserRoles;
}
